module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/TaKpLy/tc-custom/9780544279575.jpg?1737056305396",
      "alt": "This image is the cover for the book Watcher and Other Stories"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Watcher and Other Stories\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("This collection of three long stories by the author of"), _c('i', [_vm._v("Cosmicomics")]), _vm._v(" “demonstrates clearly his talent for transforming the mundane into the marvelous” ("), _c('i', [_vm._v("The New York Times")]), _vm._v(").")]), _c('br'), _c('br'), _vm._v("Italo Calvino is widely recognized as one of postwar Italy’s greatest fiction writers and one of the twentieth century’s greatest fabulists. This collection of three stories showcases his range and virtuosity."), _c('br'), _c('br'), _vm._v("In the title story, an Italian Communist poll watcher is stationed at a hospital in Turin, where nuns guide the hands of invalids to their preferred candidate in a special election. In “Smog,” a city’s cooperative laundry facility reveals a harbinger of social purification. And in “The Argentine Ant,” the citizens of a provincial seaside town struggle against a government-controlled infestation."), _c('br'), _c('br'), _c('b', [_vm._v("“Like Jorge Luis Borges and Gabriel García Márquez, Italo Calvino dreams perfect dreams for us.” —John Updike, "), _c('i', [_vm._v("New Yorker")])])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Italo Calvino\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Houghton Mifflin Harcourt (www.hmhco.com)\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0